import { Block } from 'baseui/block';
import { ObjectAlarms } from '../../../features/Alarm/ObjectAlarms'
import { themedUseStyletron } from '../../../theme/customTheme';
import { IPID } from './types'
import { SmallPanel } from './SmallPanel'
import { TimeSeriesLineChart } from '../../../features/Charts/LineCharts/TimeSeriesLineChart';
import { useIntl } from 'react-intl';


export const OperatorPanel = (props: IPID) => {
    const [css, theme] = themedUseStyletron();
    const intl = useIntl();

    return (
        <Block display='flex' flexDirection='column' alignItems='center' justifyContent='center' gridGap='40px'>
            <SmallPanel {...props}></SmallPanel>
            <ObjectAlarms resourceGroupId={props.resourceGroupId} id={props.id} />
            <TimeSeriesLineChart lines={[{
                label: intl.formatMessage({id: 'Functions.Output', defaultMessage: 'Output' }),
                lineColor: theme.appColors.aggregate.output,
                objectId: props.id,
                resourceGroupId: props.resourceGroupId,
                propertyName: 'y',
                currentValue: props.y,
                showPoints: false,
                fill: false,
                grace: 0,
            },
            {
                label: intl.formatMessage({id: 'Functions.Setpoint', defaultMessage: 'Setpoint' }),
                lineColor: theme.appColors.aggregate.setpoint,
                objectId: props.id,
                resourceGroupId: props.resourceGroupId,
                propertyName: 'w',
                currentValue: props.w,
                showPoints: true,
                fill: false,
                yScaleId: 'y1',
                grace: 0,
            },
            {
                label: intl.formatMessage({id: 'Functions.ActualValue', defaultMessage: 'Actual Value' }),
                lineColor: theme.appColors.aggregate.actualValue,
                objectId: props.id,
                resourceGroupId: props.resourceGroupId,
                propertyName: 'x',
                currentValue: props.x,
                showPoints: false,
                fill: false,
                yScaleId: 'y1',
                grace: 0,
            }]}
            showLegend
            showTimeNavigation
            enableZoom
            summarizeBy={'1s'}
            timespan={24 * 60}></TimeSeriesLineChart>

        </Block>
    )
}

